import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-disclaimer-dialog',
    templateUrl: './disclaimer-dialog.component.html',
    styleUrls: ['./disclaimer-dialog.component.css'],
    standalone: false
})
export class DisclaimerDialogComponent {

  showPdf: boolean = false;
  isSmallScreen: boolean = window.innerWidth < 415;
  path: string = '/en-CA/assets/pdfs/ScheduleA_TermsConditions.pdf';

  constructor(
    public dialogRef: MatDialogRef<DisclaimerDialogComponent>,
  ) { this.initialize() }


  initialize(): void {
    this.dialogRef.disableClose = true;
  }

  agree(): void {
    this.dialogRef.close(true);
  }

  back(): void {
    this.dialogRef.close(false);
  }

  termsConditionsClick(): void {
    this.showPdf = true;
  }

  backToDialog(): void {
    this.showPdf = false;
  }

}
